import { render, staticRenderFns } from "./AdminAppNotifications.vue?vue&type=template&id=166710fd"
import script from "./AdminAppNotifications.vue?vue&type=script&lang=js"
export * from "./AdminAppNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('166710fd')) {
      api.createRecord('166710fd', component.options)
    } else {
      api.reload('166710fd', component.options)
    }
    module.hot.accept("./AdminAppNotifications.vue?vue&type=template&id=166710fd", function () {
      api.rerender('166710fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminAppNotifications.vue"
export default component.exports